<template>
    <div id="activity" class="maincont item-setting">
        <div class="ef--inner2">
            <!-- Tab links -->
            <div class="setting-tab">
                <ul>
                    <li
                        class="nav-item"
                        v-for="tab in tabs"
                        :key="tab.id"
                        @click="onSelectTab(tab.id)"
                        :class='{"active": (tab.id == selectedTab)}'
                        >
                       <span>{{ tab.title }}</span>
                    </li>
                </ul>
            </div>
            <div class="page-info page-info-frame">
                <!-- import_export_tab -->
                <div id="import_export_tab" class="import-export-tab" v-show="isShowImportExportTab">
                    <div class="wrap-content">          
                        <div class="form-group group-input">
                            <label class="label-title">設定データファイル：</label>
                            <input type="text" class="input-field" v-model="fileName" readonly />
                            <input 
                                type="file" 
                                class="hide" 
                                ref="refImportFile"
                                name="import_file" 
                                data-vv-as="ファイル選択" 
                                v-validate="'required|size:10240|ext:xls,xlsx'"
                                data-vv-scope="import_export_tab"
                                @change="onChangeImportExcel" />
                            <a href="javascript:void(0);" class="bt-cyan choose-upload-file" @click="onChooseImportFile">ファイル選択</a>
                            <div class="err_message"> {{ errors.first("import_export_tab.import_file") }}</div>
                        </div>
                        <div class="form-group group-button">
                            <div class="group-left">
                                <button type="button" class="bt-cyan" @click="onImportFile">Import</button>
                            </div>
                            <div class="group-right">
                                <button type="button" class="bt-cyan" @click="onExportFile">Export</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- binary_item_tab -->
                <div id="binary_item_tab" class="binary-item-tab" v-show="isShowBinaryItemTab">
                    <div class="wrap-content">
                        <ul class="d-flex justify-content-between control-items">
                            <li>
                                <pagination
                                    :maxRecord="binaryItemTotalRecord"
                                    :totalPages="binaryItemTotalPages"
                                    :currentPage="binaryItemCurrentPage"
                                    @pagechanged="onChangePageBinaryItem">
                                </pagination>
                            </li>
                            <li>
                                <ul class="d-flex">
                                    <li class="button-item"><button type="button" class="bt-cyan" @click="onRegisterBinaryItem">登録</button></li>
                                    <li class="button-item"><button type="button" class="bt-cyan bt-gray" @click="onResetBinaryItem">キャンセル</button></li>
                                </ul>
                            </li>
                        </ul>
                        <div class="scroll" style="height: 580px;">
                            <table id="maintenance-table" class="normal-table">
                                <thead>
                                    <tr>
                                        <th class="d-mw-30">No.</th>
                                        <th>名称</th>
                                        <th>コード</th>
                                        <th>設備区分</th>
                                        <th>状態区分</th>
                                        <th>ON時名称</th>
                                        <th>OFF時名称</th>
                                        <th>メール通知</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in displayBinaryItemList" v-bind:key="index">
                                        <td>{{ getBinaryItemNo(index) }}</td>
                                        <td class="text-left">{{ item.name }}</td>
                                        <td>{{ item.code }}</td>
                                        <td>
                                            <span class="select-box">
                                                <select 
                                                    v-model="item.equipment_id" >
                                                    <option 
                                                        v-for="(option, index) in equipmentItemList"
                                                        v-bind:value="option.equipment_id"
                                                        v-bind:key="index">{{ option.equipment_name }}</option>
                                                </select>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="select-box">
                                                <select 
                                                    v-model="item.status_id" >
                                                    <option 
                                                        v-for="(option, index) in statusDivisionList"
                                                        v-bind:value="option.status_id"
                                                        v-bind:key="index">{{ option.status_name_jp }}</option>
                                                </select>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="select-box">
                                                <select 
                                                    v-model="item.on_off_name_id">
                                                    <option :value="item.on_off_name_id" style="display: none;">{{ getOnNameDisplay(item.on_off_name_id) }}</option>
                                                    <option 
                                                        v-for="(option, index) in onOffDisplayNameList"
                                                        v-bind:value="option.on_off_name_id"
                                                        :disabled="item.on_off_name_id == option.on_off_name_id"
                                                        v-bind:key="index">{{option.on_off_name}}</option>
                                                </select>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="select-box">
                                                <select 
                                                    v-model="item.on_off_name_id">
                                                    <option :value="item.on_off_name_id" style="display: none;">{{ getOffNameDisplay(item.on_off_name_id) }}</option>
                                                    <option 
                                                        v-for="(option, index) in onOffDisplayNameList"
                                                        v-bind:value="option.on_off_name_id"
                                                        :disabled="item.on_off_name_id == option.on_off_name_id"
                                                        v-bind:key="index">{{ option.on_off_name }}</option>
                                                </select>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="select-box">
                                                <select 
                                                    v-model="item.mail_notification" 
                                                    :disabled="item.tag == 'ST'">
                                                    <option 
                                                        v-for="(option, index) in mailNotificationList"
                                                        v-bind:value="option.value"
                                                        v-bind:key="index">{{ option.name }}</option>
                                                </select>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <!-- numerical_item_tab -->
                <div id="numerical_item_tab" class="numerical-item-tab" v-show="isShowNumericalItemTab">
                    <div class="wrap-content">
                        <ul class="d-flex justify-content-between control-items">
                            <li>
                                <pagination
                                    :maxRecord="numericalItemTotalRecord"
                                    :totalPages="numericalItemTotalPages"
                                    :currentPage="numericalItemCurrentPage"
                                    @pagechanged="onChangePageNumericalItem">
                                </pagination>
                            </li>
                            <li>
                                <ul class="d-flex">
                                    <li class="button-item"><button type="button" class="bt-cyan" @click="onRegisterNumericalItem">登録</button></li>
                                    <li class="button-item"><button type="button" class="bt-cyan bt-gray" @click="onResetNumericalItem">キャンセル</button></li>
                                </ul>
                            </li>
                        </ul>
                        <div class="scroll" style="height: 580px;">
                            <table id="maintenance-table" class="normal-table">
                                <thead>
                                    <tr>
                                        <th class="d-mw-30">No.</th>
                                        <th>名称</th>
                                        <th>コード</th>
                                        <th>設備区分</th>
                                        <th>工学値変換</th>
                                        <th>工学値変換<br />係数</th>
                                        <th>小数点以下<br />桁数</th>
                                        <th>単位</th>
                                        <th>集計方法<br />(30分)</th>
                                        <th>集計方法<br />(時)</th>
                                        <th>集計方法<br />(日)</th>
                                        <th>集計方法<br />(月)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in displayNumericalItemList" v-bind:key="index">
                                        <td>{{ getNumericalItemNo(index) }}</td>
                                        <td class="text-left">{{ item.name }}</td>
                                        <td>{{ item.code }}</td>
                                        <td>
                                            <span class="select-box">
                                                <select 
                                                    v-model="item.equipment_id" >
                                                    <option 
                                                        v-for="(option, index) in equipmentItemList"
                                                        v-bind:value="option.equipment_id"
                                                        v-bind:key="index">{{ option.equipment_name }}</option>
                                                </select>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="select-box">
                                                <select 
                                                    v-model="item.engineering_value_conversion" >
                                                    <option 
                                                        v-for="(option, index) in engineeringValueConversionList"
                                                        v-bind:value="option.value"
                                                        v-bind:key="index">{{ option.name }}</option>
                                                </select>
                                            </span>
                                        </td>
                                        <td>
                                            <input type="number" 
                                                class="input-field"
                                                v-model="item.engineering_value_coefficient">
                                        </td>
                                        <td>
                                            <span class="select-box">
                                                <select 
                                                    v-model="item.decimal_digit" >
                                                    <option 
                                                        v-for="(option, index) in decimalDigitList"
                                                        v-bind:value="option"
                                                        v-bind:key="index">{{ option }}</option>
                                                </select>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="select-box">
                                                <select 
                                                    v-model="item.unit_id" >
                                                    <option 
                                                        v-for="(option, index) in unitInfoList"
                                                        v-bind:value="option.unit_id"
                                                        v-bind:key="index">{{ option.unit_name }}</option>
                                                </select>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="select-box">
                                                <select 
                                                    v-model="item.aggregation_half_hour" >
                                                    <option 
                                                        v-for="(option, index) in aggregationList"
                                                        v-bind:value="option.value"
                                                        v-bind:key="index">{{ option.name }}</option>
                                                </select>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="select-box">
                                                <select 
                                                    v-model="item.aggregation_hour" >
                                                    <option 
                                                        v-for="(option, index) in aggregationList"
                                                        v-bind:value="option.value"
                                                        v-bind:key="index">{{ option.name }}</option>
                                                </select>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="select-box">
                                                <select 
                                                    v-model="item.aggregation_day" >
                                                    <option 
                                                        v-for="(option, index) in aggregationList"
                                                        v-bind:value="option.value"
                                                        v-bind:key="index">{{ option.name }}</option>
                                                </select>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="select-box">
                                                <select 
                                                    v-model="item.aggregation_month" >
                                                    <option 
                                                        v-for="(option, index) in aggregationList"
                                                        v-bind:value="option.value"
                                                        v-bind:key="index">{{ option.name }}</option>
                                                </select>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable */
import Pagination from "../../components/Pagination";
import { Validator } from 'vee-validate';
import { event } from "jquery";

const dict = {
  custom: {
    import_file: {
      required: () => 'ファイル選択は必須項目です',
      ext: () => '. xls又は.xlsxの拡張子があるファイルを選択してください。',
      size: () => 'ファイル選択は10MB以内でなければなりません。'
    },
  }
}
Validator.localize('ja', dict);

  export default {
    name: "item-setting",
    components: {
        Pagination,
    },
    data: function () {
        return {
            accountId: "",
            areaId: 0,
            selectedTab: 'import_export_tab',
            tabs: [
                {
                    'id': 'import_export_tab',
                    'title': 'Import/Export',
                },
                {
                    'id': 'binary_item_tab',
                    'title': '2値項目設定',
                },
                {
                    'id': 'numerical_item_tab',
                    'title': '数値項目設定',
                },
            ],
            fileData: null,
            fileName: '',
            binaryItemTotalPages: 1,
            binaryItemCurrentPage: 1,
            perPage: 50,
            binaryItemTotalRecord: 0,
            equipmentItemList: [],
            statusDivisionList: [],
            onOffDisplayNameList: [],
            onOffDisplayNameMap: new Map(),
            mailNotificationList: [
                {
                    value : true,
                    name : '有効'
                },
                {
                    value : false,
                    name : '無効'
                },
            ],
            binaryItemList: [],
            numericalItemTotalRecord: 0,
            numericalItemTotalPages: 1,
            numericalItemCurrentPage: 1,
            engineeringValueConversionList: [
                {
                    value : true,
                    name : '有効'
                },
                {
                    value : false,
                    name : '無効'
                },
            ],
            decimalDigitList: [0,1,2,3,4,5,6],
            unitInfoList: [],
            aggregationList: [
                {
                    value: "total", 
                    name:"合計"
                },
                {
                    value: "average", 
                    name: "平均"
                },
                {
                    value: "max", 
                    name:"最大値"
                },
                {
                    value: "min", 
                    name:"最小値"
                },
                {
                    value: "final", 
                    name:"最終値"
                }
            ],
            numericalItemList: []
        }
    },
    computed: {
        isShowImportExportTab: function() {
            return this.selectedTab === 'import_export_tab'
        },
        isShowBinaryItemTab: function() {
            return this.selectedTab === 'binary_item_tab'
        },
        isShowNumericalItemTab: function() {
            return this.selectedTab === 'numerical_item_tab'
        },
        displayBinaryItemList() {
            return this.paginateBinaryItem(this.binaryItemList);
        },
        displayNumericalItemList() {
            return this.paginateNumericalItem(this.numericalItemList);
        }
    },
    mounted: function() {
        this.accountId = this.$route.params.id
        console.log("item setting:mounted with  accountId: %o", this.accountId);
        this.getClusterIdAndAreaId()
    },
    methods: {
        paginateBinaryItem (binaryItemList) {
            if (!binaryItemList) return

            let dataLength = binaryItemList.length
            if (dataLength == 0) {
                dataLength = 1
            }
            this.binaryItemTotalPages = Math.ceil(dataLength / this.perPage)
            let page = this.binaryItemCurrentPage;
			let perPage = this.perPage;
			let from = (page * perPage) - perPage;
			let to = (page * perPage);
			return binaryItemList.slice(from, to);
        },
        paginateNumericalItem (numericalItemList) {
            if (!numericalItemList) return

            let dataLength = numericalItemList.length
            if (dataLength == 0) {
                dataLength = 1
            }
            this.numericalItemTotalPages = Math.ceil(dataLength / this.perPage)
            let page = this.numericalItemCurrentPage;
			let perPage = this.perPage;
			let from = (page * perPage) - perPage;
			let to = (page * perPage);
			return numericalItemList.slice(from, to);
        },
        onChangePageBinaryItem: function(page) {
            this.binaryItemCurrentPage = page;
        },
        onChangePageNumericalItem: function(page) {
            this.numericalItemCurrentPage = page;
        },
        getClusterIdAndAreaId: function() {
            const params = new URLSearchParams();
            params.append("account", this.accountId);

            const request = {
                params: params,
                withCredentials: true
            };

            this.$axios
            .get(`/srv/api/account_master_es/cluster_id_and_area_id`, request)
            .then(response => {
                console.log("[GET][api/account_master_es/cluster_id_and_area_id] : OK");
                if (typeof response.data == "object") {
                    this.areaId = response.data.area_id;
                } else {
                    // stringのときはセッションタイムアウト
                    alert("sesssion time out");
                    this.$store.dispatch("logout");
                    this.$router.push("/login");
                }
            })
            .catch(error => {
                console.log(error);
            });
        },
        onSelectTab: function(tabName){
            this.selectedTab = tabName
            switch(this.selectedTab) {
                case 'binary_item_tab':
                    this.loadBinaryItem()
                    break
                case 'numerical_item_tab':
                    this.loadNumericalItem()
                    break
            }
        },
        onChangeImportExcel: function() {
            this.$validator.validateAll('import_export_tab').then(valid => {
                if (valid) {
                    this.fileData = this.$refs.refImportFile.files[0]
                    this.fileName = this.fileData.name
                } else {
                    this.fileData = null
                    this.fileName = ''
                }
            })
        },
        onChooseImportFile: function() {
            // reset file
            this.$refs.refImportFile.value = ''
            this.fileData = null;
            this.fileName = ''
            this.$refs.refImportFile.click()
        },
        onImportFile: function() {

            this.$validator.validateAll('import_export_tab').then(valid => {
                if (valid) {
                    const formData = new FormData();
                    formData.append("file", this.fileData); 
                    formData.append("area_id", this.areaId);
                    this.$store.dispatch("setLoading", true)
                    this.$axios
                    .post(`/srv/api/item_setting/import_csv`, formData, {
                        withCredentials: true,
                    })
                    .then(response => {
                        this.$store.dispatch("setLoading", false)
                        const data = response.data;
                        if (data.status !== undefined) {
                            if (data.status === "success") {
                                console.log("[POST][/srv/api/item_setting/import_csv]: OK");
                                
                                alert("ファイルアップロードに成功しました。");
                            } else {
                                console.log("[POST]/srv/api/item_setting/import_csv]: error");
                                alert("ファイルアップロードに失敗しました。");
                            }
                        } else {
                            console.log("[POST][/srv/api/item_setting/import_csv]: error");
                            alert("ファイルアップロードに失敗しました。");
                        }
                    })
                    .catch(error => {
                        this.$store.dispatch("setLoading", false)
                        console.log(error);
                    });
                }
            })
        },
        onExportFile: function() {
            this.$store.dispatch("setLoading", true)
            const params = new URLSearchParams();
            params.append("area_id", this.areaId);

            const request = {
                params: params,
                withCredentials: true,
                responseType: "blob",
                exposedHeaders: ["Content-Disposition"]
            };
            this.$axios
            .get(`/srv/api/item_setting/export_csv`, request)
            .then(response => {
                const dateTime = (new Date()).toISOString().split('T')[0]
                const fileType = '.xlsx'
                const filename = '電衛門項目設定' + dateTime + fileType || '電衛門項目設定.xlsx'

                if (
                    response.headers["content-type"].indexOf("application/json") != -1
                ) {
                    alert("ダウンロードできませんでした");
                    this.$store.dispatch("setLoading", false)
                    return;
                }
                const dl = document.getElementById("downloadLink");
                if (dl != undefined) dl.parentNode.removeChild(dl);

                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' }));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("id", "downloadLink");
                link.setAttribute("download", filename);
                document.body.appendChild(link);
                link.click();
                this.$emit("close");
                this.$store.dispatch("setLoading", false)
            })
            .catch(error => {
                this.$store.dispatch("setLoading", false)
                console.log(error);
            });
        },
        getEquipmentItemList: function() {
            this.$axios
            .get(`/srv/api/equipment_item`, {
                withCredentials: true
            })
            .then(response => {
                console.log("[GET][api/equipment_item] : OK");
                if (typeof response.data == "object") {
                    this.equipmentItemList = response.data.equipment_items;
                } else {
                    // stringのときはセッションタイムアウト
                    alert("sesssion time out");
                    this.$store.dispatch("logout");
                    this.$router.push("/login");
                }
            })
            .catch(error => {
                console.log(error);
            });
        },
        getStatusDivisionList: function() {
            this.$axios
            .get(`/srv/api/item_setting/status_division`, {
                withCredentials: true
            })
            .then(response => {
                console.log("[GET][api/item_setting/status_division] : OK");
                if (typeof response.data == "object") {
                    this.statusDivisionList = response.data.status_divisions
                        .filter(res => (res.status_name_jp !== '欠測' && res.status_name_jp !== '通信異常'))
                } else {
                    // stringのときはセッションタイムアウト
                    alert("sesssion time out");
                    this.$store.dispatch("logout");
                    this.$router.push("/login");
                }
            })
            .catch(error => {
                console.log(error);
            });
        },
        getOnOffDisplayNameList: function() {
            this.$axios
            .get(`/srv/api/on_off_display_name`, {
                withCredentials: true
            })
            .then(response => {
                console.log("[GET][api/on_off_display_name] : OK");
                if (typeof response.data == "object") {
                    let dataMap = new Map()
                    let data = response.data.on_off_display_names;
                    for(let i = 0; i < data.length; i++) {
                        let name = ''
                        if (data[i].on_name && data[i].off_name) {
                            name = data[i].on_name + ',' + data[i].off_name
                        } else if (data[i].on_name) {
                            name = data[i].on_name
                        } else if (data[i].off_name) {
                            name = data[i].off_name
                        }                        
                        data[i].on_off_name = name
                        // map 
                        this.onOffDisplayNameMap.set(data[i].on_off_name_id, data[i])
                    }
                    this.onOffDisplayNameList = data;

                } else {
                    // stringのときはセッションタイムアウト
                    alert("sesssion time out");
                    this.$store.dispatch("logout");
                    this.$router.push("/login");
                }
            })
            .catch(error => {
                console.log(error);
            });
        },
        getBinaryItemList: function() {
            this.binaryItemCurrentPage = 1;

            const params = new URLSearchParams();
            params.append("area_id", this.areaId);
            params.append("page", this.binaryItemCurrentPage - 1);

            const request = {
                params: params,
                withCredentials: true
            };
            
            this.$axios
            .get(`/srv/api/item_setting/binary_item`, request)
            .then(response => {
                console.log("[GET][api/item_setting/binary_item] : OK");
                if (typeof response.data == "object") {
                    this.binaryItemList = response.data.binary_items;
                    
                    this.binaryItemTotalRecord = this.binaryItemList.length
                    // this.binaryItemTotalPages = response.data.total_page
                } else {
                    // stringのときはセッションタイムアウト
                    alert("sesssion time out");
                    this.$store.dispatch("logout");
                    this.$router.push("/login");
                }
            })
            .catch(error => {
                console.log(error);
            });
        },
        loadBinaryItem: function() {
            this.getEquipmentItemList()
            this.getStatusDivisionList()
            this.getOnOffDisplayNameList()
            this.getBinaryItemList()
        },
        onResetBinaryItem: function() {
            this.getBinaryItemList()
        },
        onRegisterBinaryItem: function() {
            const ans = confirm('全ページ保存しますか？')
            if (ans) {
                const params = {
                            'binary_items': this.binaryItemList
                        };
                this.$axios
                .post(`/srv/api/item_setting/binary_item`, params, {
                    withCredentials: true
                })
                .then(response => {
                    const data = response.data;
                    if (data.status !== undefined) {
                        if (data.status === "success") {
                            console.log("[POST][api/item_setting/binary_item] : OK")
                            alert("登録が完了しました。");
                        } else {
                            console.log("[POST][api/item_setting/binary_item] : fail")
                            alert("登録できませんでした");
                        }
                    } else {
                        console.log("[POST][api/item_setting/binary_item] : fail")
                        alert("登録できませんでした");
                    }
                })
                .catch(error => {
                    console.log(error)
                })
            }
        },       
        getUnitInfoList: function() {
            this.$axios
            .get(`/srv/api/unit_info`, {
                withCredentials: true
            })
            .then(response => {
                console.log("[GET][api/item_setting/unit_info] : OK");
                if (typeof response.data == "object") {
                    this.unitInfoList = response.data.unit_infos;
                } else {
                    // stringのときはセッションタイムアウト
                    alert("sesssion time out");
                    this.$store.dispatch("logout");
                    this.$router.push("/login");
                }
            })
            .catch(error => {
                console.log(error);
            });
        },
        getNumericalItemList: function() {
            this.numericalItemCurrentPage = 1;

            const params = new URLSearchParams();
            params.append("area_id", this.areaId);
            params.append("page", this.numericalItemCurrentPage - 1);

            const request = {
                params: params,
                withCredentials: true
            };
            
            this.$axios
            .get(`/srv/api/item_setting/numerical_item`, request)
            .then(response => {
                console.log("[GET][api/item_setting/numerical_item] : OK");
                if (typeof response.data == "object") {
                    this.numericalItemList = response.data.numerical_items;
                    // this.numericalItemTotalPages = response.data.total_page
                    this.numericalItemTotalRecord = this.numericalItemList.length
                } else {
                    // stringのときはセッションタイムアウト
                    alert("sesssion time out");
                    this.$store.dispatch("logout");
                    this.$router.push("/login");
                }
            })
            .catch(error => {
                console.log(error);
            });
        },
        loadNumericalItem: function() {
            this.getEquipmentItemList()
            this.getUnitInfoList()
            this.getNumericalItemList()
        },
        onRegisterNumericalItem: function() {
            const ans = confirm('全ページ保存しますか？')
            if (ans) {
                const params = {
                    'numerical_items': this.numericalItemList
                };
                this.$axios
                .post(`/srv/api/item_setting/numerical_item`, params, {
                    withCredentials: true
                })
                .then(response => {
                    const data = response.data;
                    if (data.status !== undefined) {
                        if (data.status === "success") {
                            console.log("[POST][api/item_setting/numerical_item] : OK")
                            alert("登録が完了しました。");
                        } else {
                            console.log("[POST][api/item_setting/numerical_item] : fail")
                            alert("登録できませんでした");
                        }
                    } else {
                        console.log("[POST][api/item_setting/numerical_item] : fail")
                        alert("登録できませんでした");
                    }
                })
                .catch(error => {
                    console.log(error)
                })
            }
        },
        onResetNumericalItem: function() {
            this.numericalItemCurrentPage = 1
            this.getNumericalItemList()
        },
        getNumericalItemNo: function(index) {
            const offset = (this.numericalItemCurrentPage -1) * this.perPage
            return index + 1 + offset
        },
        getBinaryItemNo: function(index) {
            const offset = (this.binaryItemCurrentPage -1) * this.perPage
            return index + 1 + offset
        },
        getOnNameDisplay: function(on_off_name_id) {
            if (on_off_name_id && this.onOffDisplayNameMap && this.onOffDisplayNameMap.get(on_off_name_id))  {
                return this.onOffDisplayNameMap.get(on_off_name_id).on_name
            }
            return ''
        },
        getOffNameDisplay: function(on_off_name_id) {
            if (on_off_name_id && this.onOffDisplayNameMap && this.onOffDisplayNameMap.get(on_off_name_id))  {
                return this.onOffDisplayNameMap.get(on_off_name_id).off_name
            }
            return ''
        },
    },
    
  }
</script>